import _ from 'lodash'
import Url from 'url-parse'
import useIdToFindCategory from '@/views/creative/utils/use-id-to-find-category'
import { findBasicResource } from '@/store/creative/common'
import findResource, {
  findDefaultResource,
} from '@/views/creative/utils/find-resource'
import { getFileName, removeFileExtension } from '@com/utils/file'
import { isFrameSequence } from '@/views/creative/utils'

const cookPlayableBasicUrl = (previewUrl) => {
  const url = new Url(previewUrl)
  return url.origin + url.pathname.replace(/\/[^/]*\.html$/, '')
}

const cookImageBinPath = ({ previewUrl, filePath }) => {
  const basicUrl = `${cookPlayableBasicUrl(previewUrl)}/resource/`
  return filePath
    .split(',')
    .map((url) => `${basicUrl}${removeFileExtension(url)}.bin`)
}

const cookXlzBinPath = ({ previewUrl, filePath, files }) => {
  const basicUrl = `${cookPlayableBasicUrl(previewUrl)}/resource/${filePath}/`
  return files.map(
    (url) => `${basicUrl}${removeFileExtension(getFileName(url))}.bin`,
  )
}

/**
 * livePreview 实时预览资源，包括静态资源与 json
 * @param {any} param0
 * @param {{id: number, category_id: number, gameConfig: {}, i18n: {}, previewLanguage: string, attrs: {visible: boolean, volume: number}}} param1
 * id：资源 id
 */
export default async function livePreview(
  { commit, dispatch, state },
  // eslint-disable-next-line camelcase
  { id, category_id, gameConfig, i18n, previewLanguage, attrs = {}, mwConfig },
) {
  if (!state.canLivePreview) {
    return
  }

  if (gameConfig || i18n || mwConfig) {
    commit('updatePreparingPreview', true)
    // 确保接受到的i18n传参是经过decodeLanguages的
    const params = {
      gameConfig: _.cloneDeep(gameConfig),
      i18n: _.cloneDeep(i18n),
      previewLanguage,
      mwConfig: _.cloneDeep(mwConfig),
      action: 'update',
    }
    await dispatch('previewer/livePreview', params)
    commit('updatePreparingPreview', false)
    return
  }

  const category = useIdToFindCategory({
    category: state.templateConfig.category,
    categoryId: category_id,
  })
  const basicResource = findBasicResource({
    resource: state.templateConfig.resource,
    categoryId: category_id,
  })

  if (state.previewUrl) {
    if (!basicResource.file_path) {
      throw new Error('缺少 file_path')
    }
    basicResource.basic_url = cookPlayableBasicUrl(state.previewUrl)
    basicResource.bin_path = cookImageBinPath({
      previewUrl: state.previewUrl,
      filePath: basicResource.file_path_for_live_preview,
    })
    // 序列帧bin资源链接，暂时还没有用到（根据素材研发反馈，序列帧的图片暂时还没有带额外信息的场景）
    if (isFrameSequence(basicResource.prefix, basicResource.resource_type)) {
      basicResource.bin_path = cookXlzBinPath({
        previewUrl: state.previewUrl,
        filePath: basicResource.file_path,
        files: basicResource.preview_urls_for_live_preview,
      })
    }
  }

  const findCurrentResource = () => {
    const resource = null
    // 如果没有传 resource_id，主动去获取
    if (_.isUndefined(id)) {
      return (
        resource ||
        findDefaultResource({
          resource: state.templateConfig.resource,
          categoryId: category_id,
        })
      )
    }

    return findResource({
      resource: state.templateConfig.resource,
      categoryId: category_id,
      id: id,
    })
  }
  const currentResource = findCurrentResource()

  let { volume } = attrs
  const { visible } = attrs
  let soundDisabled
  // 音频文件隐藏的话，设置soundDisabled=true, 显示时重新赋值volume
  if (category.file_type === 'audio' && typeof visible !== 'undefined') {
    soundDisabled = !visible
    volume = (category.properties || {}).volume || 0
  }

  await dispatch('previewer/livePreview', {
    category,
    resource: currentResource,
    basicResource,
    action: 'update',
    visible,
    volume,
    soundDisabled,
  })
}
